<template>
  <div class="c-wrap">
    <div class="c-fixed">
      <div class="c-search-box">
        <!-- <i class="iconfont icon-sousuo"></i> -->

        <form action @submit.prevent>
          <input
            ref="input-dom"
            type="search"
            v-model="keywords"
            placeholder="请输入"
            @keyup.enter="doSearch"
          />
        </form>
      </div>
      <div class="c-search-btn" @click="jumpBack">取消</div>
    </div>
    <ul class="c-list">
      <li v-for="item in list.nodes" :key="item.id" @click="jumpToNote(item)">
        <list-item :item="item"></list-item>
      </li>
    </ul>
    <div class="c-no-data" v-if="nodata">
      <img src="~@/assets/images/search/no-search-res.png" />
      <div class="text">没有查询到相关内容，换个词试试</div>
    </div>
  </div>
</template>

<script>
import dates from '@/utils/dates'
import ListItem from './components/list-item.vue'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
import { nextTick } from 'vue'
export default {
  components: { ListItem },
  data() {
    return {
      nodata: false,
      more: false,
      keywords: '',
      list: {
        nodes: [],
      },
      recommends: [],
      showLoading: false,
      reUrl: '',
    }
  },
  unmounted() {
    // this.removeScroll()
  },
  mounted() {
    // this.bindScroll()
    this.reUrl = decodeURIComponent(this.$route.query.reUrl)
    // this.getRecommend()
    nextTick(() => {
      this.$refs['input-dom'].focus()
    })
  },
  methods: {
    formatCourseDate(start, end) {
      return dates.formatCourseTimeCn(start, end)
    },
    jumpBack() {
      this.$router.push({
        name: 'note'
      })
    },
    doSearch() {
      this.getCourseList()
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.showLoading = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.showLoading) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    async getCourseList({ more = false } = {}) {
      if (more && !this.more) return
      this.showLoading = true
      let prev = '',
        ln = this.list.nodes.length
      prev =
        this.list.nodes[ln - 1] && this.list.nodes[ln - 1].publishTime
          ? this.list.nodes[ln - 1].publishTime
          : ''
      let res = await this.api.search.getSearchRes({
        keyword: this.keywords,
        type: 2,
        prev
      })
      if (res && res.code == 200) {
        if (more) {
          res.data.nodes.forEach((item) => {
            this.list.nodes.push(item)
          })
        } else {
          if (
            Object.prototype.toString.call(res.data.nodes) !=
              '[object Array]' ||
            res.data.nodes.length == 0
          ) {
            this.nodata = true
            // this.getRecommend()
          } else {
            this.nodata = false
          }
          if (
            Object.prototype.toString.call(res.data.nodes) == '[object Array]'
          ) {
            this.list.nodes = res.data.nodes
          }
        }
        this.more = res.data.more
      }
      this.showLoading = false
    },
    // async getRecommend() {
    //   let res = await this.api.search.getRecommend()
    //   if (res && res.code == 200) {
    //     if (
    //       Object.prototype.toString.call(res.data.nodes) == '[object Array]'
    //     ) {
    //       this.recommends = res.data.nodes
    //     }
    //   }
    // },
    loadMoreFn() {
      if (this.showLoading || !this.more) {
        return false
      }
      this.getCourseList({ more: true })
    },
    jumpToNote(item) {
      this.$router.push({
        name: 'note-study',
        query: {
          id: item.id,
          adminId: this.$route.query.adminId ? this.$route.query.adminId : '',
          origin: this.$route.query.origin,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.c-wrap {
  background: #fff;
  padding-top: 140px;
}
.c-fixed {
  width: 100%;
  padding: 32px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 2;
}
.c-search-box {
  width: 590px;
  line-height: 72px;
  background: #f9f9f9;
  border-radius: 16px;
  border: 2px solid #d8d9dc;
  padding-left: 15px;
  display: flex;
  form,
  input {
    width: 590px;
  }
  i {
    font-size: 30px;
  }
  input {
    font-size: 28px;
    color: #333;
    flex: 1 0 0;
    height: 72px;
    padding: 0 34px 0 12px;
    background: transparent;
  }
}
.c-no-data {
  img {
    width: 300px;
    height: 300px;
    display: block;
    margin: 0 auto;
  }
  .text {
    font-size: 24px;
    font-weight: 500;
    color: #aaaaaa;
    line-height: 24px;
    padding: 38px 0 50px;
    text-align: center;
  }
}
.c-search-btn {
  flex: 1 0 0;
  text-align: right;
  font-size: 30px;
  color: #333333;
  line-height: 72px;
  padding: 0 4px 0 0px;
}
.c-commend {
  border-top: 18px solid #f3f3f3;

  .c-label {
    font-size: 36px;
    font-weight: 500;
    color: #222222;
    line-height: 96px;
  }
}
.c-list {
  padding: 0 32px 40px;
  .c-item {
    padding-bottom: 40px;
    display: flex;
    .c-info {
      flex: 1;
      text-align: left;
      padding-left: 20px;
    }
    .c-title {
      width: 486px;
      height: 48px;
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
    }
    .c-desc {
      width: 486px;
      height: 64px;
      font-size: 26px;
      font-weight: 400;
      color: #666666;
      line-height: 64px;
      margin-bottom: 10px;
    }
    .c-time,
    .c-address {
      font-size: 24px;
      color: #888888;
      line-height: 36px;
    }
    .c-price {
      flex: 48px;
      text-align: right;
      display: flex;
      justify-content: space-between;
      line-height: 38px;
      .c-other {
        flex: 60% 0 0;
        text-align: right;
        font-size: 24px;
      }
      .price {
        font-weight: 500;
        color: #ff5500;
      }
    }
    .c-thumb {
      width: 180px;
      height: 240px;
      position: relative;
      .c-tag {
        position: absolute;
        width: 76px;
        line-height: 32px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 4px;
        bottom: 10px;
        right: 10px;
        z-index: 1;
        color: #f9f9f9;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
    &.hor {
      .c-thumb {
        width: 320px;
        height: 178px;
      }
      .c-title {
        width: 340px;
      }
      .c-desc {
        width: 340px;
      }
    }
  }
}
.color-f50 {
  color: #f50;
}
.color-bbb {
  color: #bbb;
}
</style>